import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface UserUpdateMatterProps {
  name?: string;
  description?: string;
  code?: string;
  userIds?: string[];
  tokenLimit?: number | null;
  // New 2.0 stuff
  isDraft?: boolean;
  issues?: string;
  disputeType?: string;
  userDefinedEntities?: string;
  additionalContext?: string;
  timePeriod?: string;
  disputeStatus?: string;
}

const useUpdateMatter = (id: string | undefined) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const updateMatter = async (data: UserUpdateMatterProps) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PATCH,
      data,
    });

    const response = await fetch(`${APIBaseChronos}/api/matters/${id}`, fetchConfig);
    if (!response.ok) {
      throw new Error('Error updating matter');
    }
    return await response.json();
  };

  return useMutation({
    mutationFn: updateMatter,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Matter, id] });
    },
    onError: (error: Error) => {
      console.error('Update matter error:', error);
      toast.error(error.message || 'Failed to update matter. Please try again.');
    },
  });
};

export default useUpdateMatter;
